import { BASIC_VIEW } from 'Pages/EmailMessagePreview/const'
import { atom, atomFamily } from 'recoil'

export const pageState = atom({
  key: 'MessagePreviewsPageState',
  default: {
    loaded: false,
    loading: true,
    error: false,
    isEmptyState: false,
    severity: 'danger',
    pageTitle: '',
    view: BASIC_VIEW, // BASIC_VIEW 0 = box dei bottoni, QUICK_VIEW 1 = anteprime, FULL_VIEW 2 = anteprima full
    // {
    //   "MaxLists": 0,
    //   "MaxEmailPreviews": 0,
    //   "MaxSocialAccounts": 0,
    //   "MaxTriggers": 0,
    //   "MaxDataSyncFtp": 0
    // }
    maxState: {},
    isSending: false,
    isBee: false,
    messageType: undefined,
    clientsIdList: [],
    lastView: BASIC_VIEW
  }
})

export const previewsListState = atom({
  key: 'MessagePreviewsEmailMessagePreviewsState',
  default: {
    previewsIdList: [],
    loading: false,
    loaded: false
  }
})

export const previewCardState = atomFamily({
  key: 'MessagePreviewsPreviewCardState',
  default: {
    id: undefined,
    category: undefined,
    displayName: undefined,
    operativeSystem: undefined,
    browser: undefined,
    status: undefined,
    thumbnailImagePath: undefined,
    previewImagePath: undefined,
    loaded: false,
    imageLoading: false,
    imageLoaded: false
  }
})

export const previewModalState = atom({
  key: 'MessagePreviewsPreviewModalState',
  default: {
    show: false,
    displayName: undefined,
    browser: undefined,
    operativeSystem: undefined,
    previewImagePath: undefined
  }
})

export const previewsPollingState = atom({
  key: 'MessagePreviewsPreviewsPollingState',
  default: {
    polling: false,
    pollingIteration: 0,
    pollingInterval: 3000
  }
})

export const sendingModalState = atom({
  key: 'MessagePreviewsSendingModalState',
  default: {
    show: false
  }
})
